var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103.52 104.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:aqua;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.59,
    y1: 108.11,
    x2: 54.71,
    y2: 53.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007ed1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 36.05,
    y1: 11.24,
    x2: 86.19,
    y2: 98.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ed1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.79,95,4,89.18l27.82-50c9-8.61,8.78,17.4,13.57,25.69l0-.18,12,21.45-8.15,14.6a6.14,6.14,0,0,1-5.54,3.48H6.16A6.16,6.16,0,0,1,0,98a6.09,6.09,0,0,1,.8-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.65,81.52l1.77-2.59,0-2.24L62.76,3.56a6.16,6.16,0,0,0-11-.28h0L31.4,39.78l0,0c-1.63,3-3.24,5.94-4.91,8.93l0,0a6.16,6.16,0,0,1,10.11.46h0l9.7,17.44,19.35,34.48h0a6.14,6.14,0,0,0,5.3,3h3.36l.8-.25,7.27-3.69,9.38-9.17L96,87.44l5.62-5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.44,76.67c-.21,10.28-19,7.47-22,6.61.73,6.7,1.63,17.78-7,20.91C85.05,103,105,87.26,103.44,76.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78,56.86a2.14,2.14,0,0,1,1.32-1,2.12,2.12,0,0,1,1.64.22,2.19,2.19,0,0,1,1,1.32A2.17,2.17,0,0,1,81.77,59L68.1,82.71a2.16,2.16,0,0,1-1.33,1,2.12,2.12,0,0,1-1.64-.22h0a2.16,2.16,0,0,1-.8-3h0L78,56.86ZM60.78,25.73a2.21,2.21,0,0,1,1.32-1,2.19,2.19,0,0,1,1.65.22,2.23,2.23,0,0,1,1,1.33,2.17,2.17,0,0,1-.22,1.64h0L50.87,51.59h0a2.17,2.17,0,1,1-3.76-2.18h0L60.78,25.74Zm8.67,15.88a2.17,2.17,0,0,1,4,.53,2.19,2.19,0,0,1-.22,1.65L59.54,67.46a2.17,2.17,0,0,1-3,.79h0a2.14,2.14,0,0,1-1-1.32,2.17,2.17,0,0,1,.22-1.64h0L69.45,41.61Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.94fc669458bec5f1c59392227945692e.svg";
export { ForwardRef as ReactComponent };